function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Q3Sward"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M571.7,35.3l2.1,0l-0.5,71.8l-6.1,0l0.4-67.8C567.7,37.1,569.5,35.3,571.7,35.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M573.3,107.1l0.4-67.9c-2,1-3.4,3-3.4,5.4l-0.4,62.5L573.3,107.1z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 567,
  y: 107.2,
  transform: "matrix(-1 -6.554475e-03 6.554475e-03 -1 1139.7531 221.9978)",
  className: "st0",
  width: 6.5,
  height: 3.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M569.3,143.1l1.5,0c0.8,0,1.4-0.6,1.4-1.4l0.2-28.5c0-0.2-0.2-0.4-0.3-0.4l-3.6,0c-0.2,0-0.4,0.2-0.4,0.3 l-0.2,28.5C567.9,142.5,568.5,143.1,569.3,143.1z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 559.6,
  y: 110.9,
  transform: "matrix(-1 -6.554475e-03 6.554475e-03 -1 1139.4274 227.6643)",
  className: "st1",
  width: 21.1,
  height: 2.2
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Q3hunter"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M598.2,152.8c0,0-0.8,5.6,4.1,7.9c8.2,3.7,8.9-1.6,8.9-1.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M636.3,152.9c0,0,1.3,5.5-3.5,7.7c-8.2,3.7-8.9-1.6-8.9-1.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3 Q3playClose Q3play",
  d: "M647.5,146L637,115.1c-0.3-1-0.9-3-2.6-3.2c-0.3-3.9-0.7-7.5-0.9-10.3c-1.3-13-2.5-27.7-16.2-27.7 c-13.7,0-15.2,15.3-16.4,28.5c-0.2,2.6-0.5,5.8-0.8,9.4l0,0c-1.8,0-2.4,2.1-2.8,3.2L586.8,146c-0.4,1.1,0.1,2.3,0.9,2.7 c0.9,0.4,1.9-0.1,2.2-1.1l9.3-25.4c-0.9,11.5-1.6,23.2-1.6,28.3c0,11.9,39.2,11.9,39.2,0c0-5.7-0.7-17-1.6-27.8l9,24.9 c0.4,1.1,1.4,1.6,2.2,1.1C647.4,148.2,647.8,147,647.5,146z"
}, /*#__PURE__*/React.createElement("animate", {
  className: "Q3moveHand-close",
  attributeName: "d",
  attributeType: "XML",
  dur: "0.35s",
  begin: "none",
  fill: "freeze",
  from: "M647.5,146L637,115.1c-0.3-1-0.9-3-2.6-3.2c-0.3-3.9-0.7-7.5-0.9-10.3c-1.3-13-2.5-27.7-16.2-27.7c-13.7,0-15.2,15.3-16.4,28.5c-0.2,2.6-0.5,5.8-0.8,9.4l0,0c-1.8,0-2.4,2.1-2.8,3.2L586.8,146c-0.4,1.1,0.1,2.3,0.9,2.7c0.9,0.4,1.9-0.1,2.2-1.1l9.3-25.4c-0.9,11.5-1.6,23.2-1.6,28.3c0,11.9,39.2,11.9,39.2,0c0-5.7-0.7-17-1.6-27.8l9,24.9c0.4,1.1,1.4,1.6,2.2,1.1C647.4,148.2,647.8,147,647.5,146z",
  to: "M647.5,146L637,115.1c-0.3-1-0.9-3-2.6-3.2c-0.3-3.9-0.7-7.5-0.9-10.3c-1.3-13-2.5-27.7-16.2-27.7c-13.7,0-15.2,15.3-16.4,28.5c-0.2,2.6-0.5,5.8-0.8,9.4l0,0c-1.8,0-2.4,2.1-2.8,3.2L567,116c-1,0-4,0.7-4,3c0,2.3,1.7,2.9,4,2.9l32.3,0.3c-0.9,11.5-1.6,23.2-1.6,28.3c0,11.9,39.2,11.9,39.2,0c0-5.7-0.7-17-1.6-27.8l9,24.9c0.4,1.1,1.4,1.6,2.2,1.1C647.4,148.2,647.8,147,647.5,146z"
}), /*#__PURE__*/React.createElement("animate", {
  className: "Q3moveHand-far",
  attributeName: "d",
  attributeType: "XML",
  dur: "0.35s",
  begin: "none",
  fill: "freeze",
  to: "M647.5,146L637,115.1c-0.3-1-0.9-3-2.6-3.2c-0.3-3.9-0.7-7.5-0.9-10.3c-1.3-13-2.5-27.7-16.2-27.7c-13.7,0-15.2,15.3-16.4,28.5c-0.2,2.6-0.5,5.8-0.8,9.4l0,0c-1.8,0-2.4,2.1-2.8,3.2L586.8,146c-0.4,1.1,0.1,2.3,0.9,2.7c0.9,0.4,1.9-0.1,2.2-1.1l9.3-25.4c-0.9,11.5-1.6,23.2-1.6,28.3c0,11.9,39.2,11.9,39.2,0c0-5.7-0.7-17-1.6-27.8l9,24.9c0.4,1.1,1.4,1.6,2.2,1.1C647.4,148.2,647.8,147,647.5,146z",
  from: "M647.5,146L637,115.1c-0.3-1-0.9-3-2.6-3.2c-0.3-3.9-0.7-7.5-0.9-10.3c-1.3-13-2.5-27.7-16.2-27.7c-13.7,0-15.2,15.3-16.4,28.5c-0.2,2.6-0.5,5.8-0.8,9.4l0,0c-1.8,0-2.4,2.1-2.8,3.2L567,116c-1,0-4,0.7-4,3c0,2.3,1.7,2.9,4,2.9l32.3,0.3c-0.9,11.5-1.6,23.2-1.6,28.3c0,11.9,39.2,11.9,39.2,0c0-5.7-0.7-17-1.6-27.8l9,24.9c0.4,1.1,1.4,1.6,2.2,1.1C647.4,148.2,647.8,147,647.5,146z"
})), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 602.2,
  y1: 177.8,
  x2: 604.2,
  y2: 161.4
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M605.4,181.4l-9.8-0.1c0,0,4.1-3.8,7.7-3.2C606.9,178.7,605.4,181.4,605.4,181.4z"
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 632.8,
  y1: 177.8,
  x2: 630.9,
  y2: 161.4
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M629.6,181.2l9.8,0.3c0,0-4-4-7.6-3.6C628.2,178.4,629.6,181.2,629.6,181.2z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st6",
  cx: 607.6,
  cy: 95.5,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st6",
  cx: 615,
  cy: 95.5,
  r: 1
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M607.2,101.8c0.5,0.8,2.1-0.3,4.4-0.3h0c2.3,0,3.9,1.1,4.4,0.3"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  points: "600.3,102 600,105.5 601.3,106.2 601.6,102.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "634.1,102.7 634.4,106.2 633.1,106.9 632.8,103.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M609.4,151.4l-0.7,5c-0.2,1.6,1.1,3,2.7,3h11.3c1.6,0,2.8-1.3,2.7-2.9l-0.3-4.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M613.1,134c-12.7,0-14.3-3.7-14.3-3.7l-6.3,17.8c0,0,10.3,7,14.9,5.4C611.7,152.1,613.1,134,613.1,134z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M593.6,146c3.1,1.7,10.1,5,13,4.1c3-1,4.5-9.9,5.2-15.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M621.3,134c12.7,0,14.3-3.7,14.3-3.7l6.3,17.8c0,0-10.3,7-14.9,5.4C622.6,152.1,621.3,134,621.3,134z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M624.1,137.6c-3.8,12.1-27.3,7.4-27.3,7.4l1.9-10.1h22.9L624.1,137.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M622.6,135.4c-3.5,9.7-19.2,7.2-25,6.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M615.2,131.3c-7.8-0.2-12.4-1.8-14.7-2.9c-0.9-0.4-2,0-2.4,0.9l-1.2,3.1c-0.4,0.9,0.2,1.9,1.2,2.2l16.1,3.8 c1,0.2,2-0.4,2.1-1.4l0.5-3.9C617,132.2,616.2,131.3,615.2,131.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M619.4,131.3c7.7-0.2,12.3-1.8,14.5-2.9c0.9-0.4,2,0,2.4,0.9l1.2,3.1c0.3,0.9-0.2,1.9-1.2,2.2l-15.9,3.8 c-1,0.2-2-0.4-2.1-1.4l-0.5-3.9C617.6,132.2,618.4,131.3,619.4,131.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M598.9,128.5l0.4-5.8c0-0.5,0.4-0.9,0.9-1c1-0.2,1.8-1,2.1-3.6c0.5-5.3-2.2-6.2-2.2-6.2l0.5-5.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M628.5,112c0,0-0.1,2.8,1.7,6.4c1.3,2.6,3.4,3.1,4.4,3.2c0.3,0,0.6,0.3,0.6,0.6l0.5,6.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M611.8,113.3c-3.6-6.5-20.4-10.3-20.4-10.3c0.2-7.5,10.3-8.9,10.3-8.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M606.6,130.3c2-3.9,1.6-10.4,0.7-14.7c-0.3-1.2,0.7-2.4,1.9-2.3c4.8,0.1,15.1,0,19.4-1.4 c4.1-7.5,17.9-9.1,17.9-9.1c-0.5-6-13.6-8.3-13.6-8.3c0.2,1.9,0.5,5.6,0.7,7.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M628.5,112c0,0,3.2-8.3,6.3-10.4c0.9-0.6-1.5-1.4-1.5-1.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M611.8,113.3c0,0-4.6-8.2-12.4-11.6c-1-0.4,1.5-1.4,1.5-1.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M632.5,93.1c0,0,0.8,6.8,0.9,8.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M601.9,93.1c0,0-0.8,6.8-0.9,8.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M609.2,156.1c0,0,4.2,1.1,7.6,1.1c3.4,0,8.3-0.9,8.3-0.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M609.2,154.6c0,0,4.2,1.1,7.6,1.1c3.4,0,8.3-0.9,8.3-0.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M623.6,139c0,0,2.2,2.3,8.1,2.6c5.9,0.3,7.9-0.5,7.9-0.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M622.3,141.5c0,0,3.2,2.8,9.1,3.1c5.9,0.3,9.4-0.8,9.4-0.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M612.5,131c0,0,0.3-6.9,0.2-9.9c0-3-0.8-7.9-0.8-7.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M616.4,113.2c0,0,0.8,4.9,0.8,7.9S617,131,617,131"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M620.9,113.2c0,0,0.8,4.9,0.8,7.9s-0.2,9.9-0.2,9.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M625.4,113.2c0,0,0.8,4.9,0.8,7.9S626,131,626,131"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M630.5,118c0.1,1.1,0.2,2.2,0.2,3.1c0,2.2-0.1,6.5-0.2,8.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M620.9,131.5c0,0,0,3.8,0.4,4.1c0.9,0.6,11.2-2.2,16-3.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M615.4,131.2c0,0,0,3.8-0.4,4.1c-0.9,0.6-12.9-2.5-17.7-3.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M630.8,151.3l-1.4,0.4c-0.4,0.1-0.9-0.1-1-0.6l-1-3.7c-0.1-0.4,0.1-0.9,0.6-1l1.4-0.4c0.4-0.1,0.9,0.1,1,0.6 l1,3.7C631.5,150.7,631.3,151.2,630.8,151.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M628.3,144c0,0-0.7,1.3,0.4,2.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M627.7,148.2c0,0,0.6,0.5,1.6,0.1c1-0.4,1.3-0.9,1.3-0.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M628.1,149.6c0,0,0.6,0.5,1.6,0.1c1-0.4,1.3-0.9,1.3-0.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M605,107.3c0,0,0.3,5.6,0.3,9c0,3.4-1.6,13-1.6,13"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M601.6,102.8c0,0,7.8,4.4,15.6,4.1c7.8-0.3,15.8-3.5,15.8-3.5"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Q3man2",
  className: "st13"
}, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M647.5,146L637,115.1c-0.3-1-0.9-3-2.6-3.2c-0.3-3.9-0.7-7.5-0.9-10.3c-1.3-13-2.5-27.7-16.2-27.7 c-13.7,0-15.2,15.3-16.4,28.5c-0.2,2.6-0.5,5.8-0.8,9.4l0,0c-1.8,0-2.4,2.1-2.8,3.2L567,116c-1,0-4,0.7-4,3c0,2.3,1.7,2.9,4,2.9 l32.3,0.3c-0.9,11.5-1.6,23.2-1.6,28.3c0,11.9,39.2,11.9,39.2,0c0-5.7-0.7-17-1.6-27.8l9,24.9c0.4,1.1,1.4,1.6,2.2,1.1 C647.4,148.2,647.8,147,647.5,146z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Q3distance"
}, /*#__PURE__*/React.createElement("line", {
  id: "Q3D",
  className: "st15",
  x1: 268,
  y1: 177.8,
  x2: 577.5,
  y2: 177.8
}), /*#__PURE__*/React.createElement("line", {
  id: "Q3left",
  className: "st16",
  x1: 268.4,
  y1: 172.1,
  x2: 268.4,
  y2: 183.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Q3right",
  className: "st16",
  x1: 577.5,
  y1: 172.1,
  x2: 577.5,
  y2: 183.5
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Q3Bow"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M576.6,154.1h-17.4c-0.4,0-0.7-0.3-0.7-0.7v-1.9c0-0.4,0.3-0.7,0.7-0.7h17.4c0.4,0,0.7,0.3,0.7,0.7v1.9 C577.3,153.8,576.9,154.1,576.6,154.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M580.6,155.8h-3.2c-0.8,0-1.4-0.6-1.4-1.4v-3.9c0-0.8,0.6-1.4,1.4-1.4h3.2c0.3,0,0.5,0.2,0.5,0.5v5.7 C581.1,155.6,580.9,155.8,580.6,155.8z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "609.4,158.7 580.6,158.7 580.6,148.2 585.5,146.8 609.4,146.8  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st17",
  points: "608.6,146.8 606,144.6 597.6,146.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M584.9,154.6h12.4c0.2,0,0.4-0.2,0.4-0.4v-1.1c0-0.2-0.2-0.4-0.4-0.4h-12.4c-0.2,0-0.4,0.2-0.4,0.4v1.1 C584.5,154.4,584.7,154.6,584.9,154.6z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st19",
  cx: 606.8,
  cy: 149.7,
  r: 0.8
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "616.4,159.5 609.4,162.1 609.4,146.8 634.8,146.8 634.8,153.1 626.2,153.3 623.3,159.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "659.8,162.2 634.8,153.3 634.8,146.8 659.8,146.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "638.7,154.7 634.8,153.3 634.8,146.8 638.7,146.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M617.9,163.6h4c0.7,0,1.4-0.6,1.4-1.4v-3.6c0-0.7-0.6-1.4-1.4-1.4h-4c-0.7,0-1.4,0.6-1.4,1.4v3.6 C616.6,163,617.2,163.6,617.9,163.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st20",
  d: "M604.3,140.5h4.6c0.4,0,0.7-0.3,0.7-0.7v-2c0-0.4-0.3-0.7-0.7-0.7h-4.6c-0.4,0-0.7,0.3-0.7,0.7v2 C603.5,140.1,603.8,140.5,604.3,140.5z"
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 609.4,
  y1: 162.1,
  x2: 598.6,
  y2: 158.7
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st19",
  points: "615.5,146.8 615.4,142.5 610.3,142.5 608.4,140.5 606,140.5 608.6,143.9 613.3,143.9 613.4,146.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st20",
  d: "M597.7,141.3h6.2c0.6,0,1.1-0.5,1.1-1.1v-2.9c0-0.6-0.5-1.1-1.1-1.1h-6.2c-0.6,0-1.1,0.5-1.1,1.1v2.9 C596.6,140.8,597.1,141.3,597.7,141.3z"
}), /*#__PURE__*/React.createElement("line", {
  className: "st21",
  x1: 639,
  y1: 149.5,
  x2: 660,
  y2: 149.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st21",
  x1: 639,
  y1: 151.5,
  x2: 660,
  y2: 151.5
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M590.7,134.7l-3.8,11.3c-0.4,1.1,0.1,2.3,0.9,2.7c0.9,0.4,1.9-0.1,2.2-1.1l3.7-10.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M641.2,139l3.1,8.5c0.4,1.1,1.4,1.6,2.2,1.1c0.9-0.4,1.3-1.6,0.9-2.7l-2.9-8.5"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Q3M"
}, /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M138.7,110c0,0-14.8,2.8-11.3,5.2c3.5,2.4,10.5,6.8,8.2,9.2c-2.3,2.5-4.8,4.4,1.3,5.8c6.1,1.5,7,5.3,5.4,10.7 c-1.6,5.4-2.5,11.1-0.2,10.9c2.4-0.3,5.7,0.5,6.5,2.8c0.8,2.3,1.8,10.2,7.6,9.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st23",
  d: "M171.7,116.3c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3 C171.1,115.1,171.7,115.6,171.7,116.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st24",
  d: "M161.3,118.5c-1.2,2.4-2.7,4.8-3.1,10.4c-0.4,6.1,1.6,13.1,2.3,13.4c1.9,0.6,7.3-15.5,7.6-17.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st25",
  d: "M171,125.7c0,0,0.5,9.9,2.4,9.4c1.1-0.3,1.5-8.5,1.6-8.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M158.3,137.9c0,0-1.7-3-2.7-2.7c-1,0.3-1,3.5-1,3.5c-0.1,0.9,1,1.4,2.2,1.1 C158.1,139.4,158.8,138.6,158.3,137.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M155.7,135.5c0,0-1.7-3-2.7-2.7c-1,0.3-1,3.5-1,3.5c-0.1,0.9,1,1.4,2.2,1.1 C155.4,137.1,156.1,136.3,155.7,135.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M153.1,126.4c0,0-0.4,4.4,0.7,4.4c1.1,0.1,1.8-2.2,1.8-2.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M149.8,125.9c0,0-0.4,4.4,0.7,4.4c1.1,0.1,2.6-2.9,2.6-2.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st27",
  d: "M157.1,121c0,0-8.7-4.7-11.7-7.9c-3-3.2-15.9-8.8-34.1-5.3c-18.2,3.5-44.2-25.1-52.1-39.5 C41.6,36,42.9,15.9,42.9,15.9s21.5,15.6,47.6,17.8c27.4,2.3,46.4,3.5,60.3,20.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st28",
  d: "M184.6,74.9c0-16.4-5.1-41.3-7.5-41.3c-2.5,0-7.5,24.9-7.5,41.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st29",
  d: "M185.8,53.1c0-15.9-5.9-40.1-8.8-40.1c-2.9,0-8.8,24.2-8.8,40.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M181.9,84.8c0-10.6-3.3-26.7-4.9-26.7c-1.6,0-4.9,16.1-4.9,26.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st28",
  d: "M166.2,63c-4.9-7.7-14.8-17.9-15.9-17.1c-1.2,0.7,3.9,14,8.8,21.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M180.2,95.6c0-6.9-2.1-17.4-3.2-17.4s-3.2,10.5-3.2,17.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M170.4,80.5c-3.1-6.1-9.8-14.5-10.7-14c-0.9,0.5,1.9,10.8,5,16.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st29",
  d: "M168.5,42.7c-3.1-6.1-11.5-13.7-13.2-12.8c-1.7,0.9-0.6,12.1,2.5,18.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M171.3,94c-2-3.8-6.1-9.1-6.7-8.8c-0.6,0.3,1.2,6.8,3.2,10.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M154.8,120.2c-0.9,2.8,0.7,9.2,1.3,9.2c0.6,0,2.3-4.4,2.5-7.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M148,116.9c-4.8,3.9-2.5,13.4-1.8,13.4c0.6,0,5.8-6.9,6.1-11.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st28",
  d: "M169.2,62c-1.6-6.7-6.2-16.4-7.2-16.1c-0.7,0.2-0.7,5.8-0.1,11.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st31",
  d: "M149.7,125.8c0,0,1.4,0.5,2.6,0.6c1.1,0.1,2.8,0.1,2.8,0.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st23",
  d: "M182.5,116.3c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3 C183,115.1,182.5,115.6,182.5,116.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st32",
  d: "M192.8,118.5c1.2,2.4,2.7,4.8,3.1,10.4c0.4,6.1-1.6,13.1-2.3,13.4c-1.9,0.6-7.3-15.5-7.6-17.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st25",
  d: "M183.1,125.7c0,0-0.5,9.9-2.4,9.4c-1.1-0.3-1.5-8.5-1.6-8.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M183.7,80.5c3.1-6.1,9.8-14.5,10.7-14c0.9,0.5-1.9,10.8-5,16.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M182.8,94c2-3.8,6.1-9.1,6.7-8.8c0.6,0.3-1.2,6.8-3.2,10.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st28",
  d: "M184.9,62c1.6-6.7,6.2-16.4,7.2-16.1c0.7,0.2,0.7,5.8,0.1,11.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st27",
  d: "M188.8,142.4c0,0,9,19,8.8,25.4c-0.2,6.4-9.4-1.8-10.8-1.8c-1.4-0.1-1.9,2.2-3.3,2.4c-1.4,0.1-3.2-1-3.9-0.5 c-0.7,0.4-1.6,6.6-2.5,6.6c-1,0-1.8-6.2-2.5-6.6c-0.7-0.4-2.5,0.6-3.9,0.5c-1.4-0.1-1.9-2.4-3.3-2.4c-1.4,0.1-10.6,8.2-10.8,1.8 c-0.2-6.4,8.8-25.4,8.8-25.4"
}), /*#__PURE__*/React.createElement("line", {
  className: "st29",
  x1: 175.7,
  y1: 145.6,
  x2: 178.6,
  y2: 145.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st28",
  x1: 164.8,
  y1: 143.5,
  x2: 162.6,
  y2: 141.4
}), /*#__PURE__*/React.createElement("line", {
  className: "st28",
  x1: 192.8,
  y1: 141.8,
  x2: 189.1,
  y2: 143.5
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M155.1,75.1c-5.2-4.8-14.7-10.5-15.4-9.7c-0.7,0.8,5.7,9.7,10.9,14.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M161.7,87.4c-3.6-4-10.2-9-10.8-8.5c-0.6,0.5,3.6,7.7,7.1,11.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M152.4,85c-3.6-2.1-9.7-4.1-10-3.6c-0.3,0.5,4.5,4.8,8.1,6.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M155,90.6c-2.9-0.9-7.6-1.1-7.8-0.5c-0.2,0.6,3.8,3.2,6.7,4.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M152.8,59.3c-3.6-4-11.3-8-12.5-7c-1.1,1,1.9,9.2,5.5,13.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M165,97.4c-2.2-2.5-6.4-5.6-6.8-5.3c-0.4,0.3,2.2,4.9,4.5,7.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M157.1,73.7c-2.5-4.7-7.9-11.1-8.6-10.7c-0.5,0.3,0.6,4.5,2.2,8.6"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M137.2,77.9c-5.2-4.8-14.7-10.5-15.4-9.7c-0.7,0.8,5.7,9.7,10.9,14.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M143.8,90.3c-3.6-4-10.2-9-10.8-8.5c-0.6,0.5,3.6,7.7,7.1,11.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M134.5,87.8c-3.6-2.1-9.7-4.1-10-3.6c-0.3,0.5,4.5,4.8,8.1,6.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M137.1,93.5c-2.9-0.9-7.6-1.1-7.8-0.5c-0.2,0.6,3.8,3.2,6.7,4.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M124.4,76.9c-4.4-1.4-11.8-1.7-12.1-0.8c-0.3,0.9,5.8,5,10.3,6.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M126.4,89.3c-4.4-1.4-11.8-1.7-12.1-0.8c-0.3,0.9,5.8,5,10.3,6.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M134.5,100c-2.6-0.3-6.6,0.5-6.7,1c-0.1,0.5,3.8,2,6.3,2.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M134.9,62.1c-3.6-4-11.3-8-12.5-7c-1.1,1,1.9,9.2,5.5,13.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M140.8,51.7c-3.6-4-11.3-8-12.5-7c-1.1,1,1.9,9.2,5.5,13.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M139.2,76.5c-2.5-4.7-7.9-11.1-8.6-10.7c-0.5,0.3,0.6,4.5,2.2,8.6"
})), /*#__PURE__*/React.createElement("path", {
  className: "st34",
  d: "M153,99.4c0,0-0.8,6.5,2.8,7.5c3.7,1,6.7-1.3,6.7-1.3l-1.7-2.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M159,104.1c0,0.5-0.4,0.9-0.9,0.9l0,0c-0.5,0-0.9-0.4-0.9-0.9v-3.9c0-0.5,1.9,1.2,1.9,1.2V104.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st36",
  d: "M165,110c0,0-3.3-10.1-13.4-10.8c-10.1-0.7-4.7-0.3-4.7-0.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M215.5,110c0,0,14.8,2.8,11.3,5.2c-3.5,2.4-10.5,6.8-8.2,9.2c2.3,2.5,4.8,4.4-1.3,5.8 c-6.1,1.5-7,5.3-5.4,10.7c1.6,5.4,2.5,11.1,0.2,10.9c-2.4-0.3-5.7,0.5-6.5,2.8c-0.8,2.3-1.8,10.2-7.6,9.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M195.8,137.9c0,0,1.7-3,2.7-2.7c1,0.3,1,3.5,1,3.5c0.1,0.9-1,1.4-2.2,1.1C196,139.4,195.3,138.6,195.8,137.9z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M198.5,135.5c0,0,1.7-3,2.7-2.7c1,0.3,1,3.5,1,3.5c0.1,0.9-1,1.4-2.2,1.1C198.7,137.1,198,136.3,198.5,135.5z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M201,126.4c0,0,0.4,4.4-0.7,4.4c-1.1,0.1-1.8-2.2-1.8-2.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M204.4,125.9c0,0,0.4,4.4-0.7,4.4c-1.1,0.1-2.6-2.9-2.6-2.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st27",
  d: "M197,121c0,0,8.7-4.7,11.7-7.9c3-3.2,15.9-8.8,34.1-5.3c18.2,3.5,44.2-25.1,52.1-39.5 c17.7-32.3,16.4-52.5,16.4-52.5s-21.5,15.6-47.6,17.8c-27.4,2.3-46.4,3.5-60.3,20.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st28",
  d: "M188,63c4.9-7.7,14.8-17.9,15.9-17.1c1.2,0.7-3.9,14-8.8,21.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st29",
  d: "M185.6,42.7c3.1-6.1,11.5-13.7,13.2-12.8c1.7,0.9,0.6,12.1-2.5,18.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M199.3,120.2c0.9,2.8-0.7,9.2-1.3,9.2c-0.6,0-2.3-4.4-2.5-7.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M206.1,116.9c4.8,3.9,2.5,13.4,1.8,13.4c-0.6,0-5.8-6.9-6.1-11.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st31",
  d: "M204.5,125.8c0,0-1.4,0.5-2.6,0.6c-1.1,0.1-2.8,0.1-2.8,0.1"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M199.1,75.1c5.2-4.8,14.7-10.5,15.4-9.7c0.7,0.8-5.7,9.7-10.9,14.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M192.4,87.4c3.6-4,10.2-9,10.8-8.5c0.6,0.5-3.6,7.7-7.1,11.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M201.8,85c3.6-2.1,9.7-4.1,10-3.6c0.3,0.5-4.5,4.8-8.1,6.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M199.1,90.6c2.9-0.9,7.6-1.1,7.8-0.5c0.2,0.6-3.8,3.2-6.7,4.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M201.4,59.3c3.6-4,11.3-8,12.5-7c1.1,1-1.9,9.2-5.5,13.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M189.1,97.4c2.2-2.5,6.4-5.6,6.8-5.3c0.4,0.3-2.2,4.9-4.5,7.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M197,73.7c2.5-4.7,7.9-11.1,8.6-10.7c0.5,0.3-0.6,4.5-2.2,8.6"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M217,77.9c5.2-4.8,14.7-10.5,15.4-9.7c0.7,0.8-5.7,9.7-10.9,14.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M210.3,90.3c3.6-4,10.2-9,10.8-8.5c0.6,0.5-3.6,7.7-7.1,11.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M219.7,87.8c3.6-2.1,9.7-4.1,10-3.6c0.3,0.5-4.5,4.8-8.1,6.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M217,93.5c2.9-0.9,7.6-1.1,7.8-0.5c0.2,0.6-3.8,3.2-6.7,4.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M229.7,76.9c4.4-1.4,11.8-1.7,12.1-0.8c0.3,0.9-5.8,5-10.3,6.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M227.7,89.3c4.4-1.4,11.8-1.7,12.1-0.8c0.3,0.9-5.8,5-10.3,6.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M219.7,100c2.6-0.3,6.6,0.5,6.7,1c0.1,0.5-3.8,2-6.3,2.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M219.3,62.1c3.6-4,11.3-8,12.5-7c1.1,1-1.9,9.2-5.5,13.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M213.3,51.7c3.6-4,11.3-8,12.5-7c1.1,1-1.9,9.2-5.5,13.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M214.9,76.5c2.5-4.7,7.9-11.1,8.6-10.7c0.5,0.3-0.6,4.5-2.2,8.6"
})), /*#__PURE__*/React.createElement("path", {
  className: "st34",
  d: "M201.1,99.4c0,0,0.8,6.5-2.8,7.5c-3.7,1-6.7-1.3-6.7-1.3l1.7-2.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M195.2,104.1c0,0.5,0.4,0.9,0.9,0.9l0,0c0.5,0,0.9-0.4,0.9-0.9v-3.9c0-0.5-1.9,1.2-1.9,1.2V104.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st36",
  d: "M189.1,110c0,0,3.3-10.1,13.4-10.8c10.1-0.7,4.7-0.3,4.7-0.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st24",
  d: "M171.9,142.5c0,0-1.7-5.8-3.5-5.7c-1.8,0.1-3,5.5-3,5.5c-0.5,1.5,1.1,2.7,3.3,2.7S172.4,144,171.9,142.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st37",
  d: "M175.6,144.9c0,0-1-3.2-1.9-3.1c-1,0.1-1.7,3.1-1.7,3.1c-0.3,0.8,0.6,1.5,1.8,1.5 C175.1,146.3,175.9,145.8,175.6,144.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st24",
  d: "M182.3,142.5c0,0,1.7-5.8,3.5-5.7c1.8,0.1,3,5.5,3,5.5c0.5,1.5-1.1,2.7-3.3,2.7S181.8,144,182.3,142.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st37",
  d: "M178.5,144.9c0,0,1-3.2,1.9-3.1c1,0.1,1.7,3.1,1.7,3.1c0.3,0.8-0.6,1.5-1.8,1.5 C179.1,146.3,178.2,145.8,178.5,144.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st29",
  d: "M177.1,126.4c11.5,0,15.4-6.8,15.9-8.3c0.9-2.5-1-6.6-4.2-8.2c-3.7-1.9-7.1,2.7-11.8,2.7 c-4.7,0-8.1-4.6-11.8-2.7c-3.2,1.6-5.1,5.7-4.2,8.2C161.7,119.6,165.5,126.4,177.1,126.4z"
}));

var SvgQ3Svg = function SvgQ3Svg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Q3svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 714.5 202",
    style: {
      enableBackground: "new 0 0 714.5 202"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQ3Svg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Q3svg.6f9d9abc.svg";
export { ForwardRef as ReactComponent };